// src/components/Header.jsx
import { useMediaQuery } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { redirect } from "../constants/config";
import GoogleTranslate from "./GoogleTranslate";

const Header = ({ open, setOpen, main, position }) => {
  const navigate = useNavigate();

  const [isMenuOpen, setMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const [isToolsOpen, setToolsOpen] = useState(false); // desktop dropdown
  const [isToolsMobileOpen, setToolsMobileOpen] = useState(false); // mobile submenu

  const largest = useMediaQuery("(min-width:1200px)");
  const mobile = useMediaQuery("(max-width:600px)");

  // Close tools dropdown when clicking outside (why: avoid sticky open states)
  const toolsRef = useRef(null);
  useEffect(() => {
    function handleClickOutside(e) {
      if (toolsRef.current && !toolsRef.current.contains(e.target)) {
        setToolsOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 0);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const toggleMenu = () => setMenuOpen((v) => !v);

  const go = (path) => {
    navigate(path);
    setMenuOpen(false);
    setToolsOpen(false);
    setToolsMobileOpen(false);
  };

  return (
    <>
      <GoogleTranslate />

      <link rel="stylesheet" href={require("../theme/home.css")} />
      <link rel="stylesheet" href={require("../theme/animate.css")} />
      <link rel="stylesheet" href={require("../theme/bootstrap.min.css")} />
      <link rel="stylesheet" href={require("../theme/hover-min.css")} />
      <link rel="stylesheet" href={require("../theme/slick.css")} />
      <link rel="stylesheet" href={require("../theme/slick-theme.css")} />
      <link rel="stylesheet" href={require("../theme/style.css")} />

      <header
        class="header-main"
        style={{
          marginBottom: "50px",
          display: "flex",
          justifyContent: "center",
          backgroundColor: isScrolled ? "#01041e" : "transparent",
          marginTop: isScrolled ? "0px" : "40px",
        }}
      >
        <div class="container" style={{ maxWidth: "85%" }}>
          <div class="row">
            <div
              class="col-lg-6 col-4"
              style={{ display: "flex", alignItems: "center" }}
            >
              <div
                class="header-logo"
                onClick={() => navigate("/")}
                style={{ cursor: "pointer" }}
              >
                <img src={require("../assets/images/home/logo.png")} alt="" />
              </div>
              {!mobile && (
                <p
                  style={{
                    marginLeft: "15px",
                    fontSize: largest ? "20px" : "18px",
                    color: "#1650C4",
                    fontFamily: "batangas",
                  }}
                >
                  PROFESSIONAL LOGISTICS NETWORK
                </p>
              )}
            </div>

            <div
              class="col-lg-6 col-8"
              style={{ marginBottom: isMenuOpen ? "20px" : "0px" }}
            >
              <div class="header-nav">
                {/* Existing member area button */}
                <div class="header-btn">
                  <a
                    href="#"
                    class="themeBtn"
                    onClick={() => (window.location.href = redirect)}
                  >
                    Member Area
                  </a>
                </div>

                {/* Burger */}
                <div class="side-menu">
                  <div id="menu" onClick={toggleMenu}>
                    <div
                      className={`menu-line1 ${isMenuOpen ? "rotate1" : ""}`}
                    ></div>
                    <div
                      className={`menu-line2 ${isMenuOpen ? "rotate2" : ""}`}
                    ></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>

      {/* ================= Mobile / Overlay Menu ================= */}
      {isMenuOpen && (
        <>
          <div className={isMenuOpen ? "nav-page1 transform" : "nav-page1"}>
            <div class="res_menu_Nav">
              <div class="side-menu" style={{ marginTop: "10px" }}>
                <div id="menu" onClick={toggleMenu}>
                  <div
                    className={`menu-line1 ${isMenuOpen ? "rotate1" : ""}`}
                  ></div>
                  <div
                    className={`menu-line2 ${isMenuOpen ? "rotate2" : ""}`}
                  ></div>
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  gap: "50px",
                  margin: "20px",
                }}
              >
                <div style={{ flexDirection: "column", display: "flex" }}>
                  <a href="#" onClick={() => go("/about")}>
                    About
                  </a>
                  <a href="#" onClick={() => go("/pro-advantage")}>
                    PRO-Advantages
                  </a>
                  <a href="#" onClick={() => go("/team")}>
                    Our Team
                  </a>
                  <a href="#" onClick={() => go("/gallery")}>
                    Gallery
                  </a>
                  <a href="#" onClick={() => go("/events")}>
                    Upcoming Events
                  </a>
                  <a href="#" onClick={() => go("/request-demo")}>
                    Request a Demo
                  </a>
                  <a href="#" onClick={() => go("/testimonial")}>
                    Testimonials
                  </a>
                  <a href="#" onClick={() => go("/contact-us")}>
                    Contact Us
                  </a>

                  {/* Tools expandable group (mobile) */}
                  <a
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                      setToolsMobileOpen((v) => !v);
                    }}
                    style={{ marginTop: 12 }}
                  >
                    Tools {isToolsMobileOpen ? "−" : "+"}
                  </a>
                  {isToolsMobileOpen && (
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        marginLeft: 16,
                      }}
                    >
                      <a href="#" onClick={() => go("/hs-code")}>
                        HS‑Code Tools
                      </a>
                      <a href="#" onClick={() => go("/tarrif-rules")}>
                        Tariff & Rules Tool
                      </a>
                    </div>
                  )}
                </div>
                <div style={{ flexDirection: "column", display: "flex" }}></div>
              </div>
            </div>
            <div class="navigation_menu">
              <a href="#" onClick={() => go("/about")}>
                About
              </a>
              <a href="#" onClick={() => go("/pro-advantage")}>
                Pro-Advantages
              </a>
              <a href="#" onClick={() => go("/team")}>
                Our Team
              </a>
              <a href="#" onClick={() => go("/gallery")}>
                Gallery
              </a>
            </div>
          </div>
          <div className={isMenuOpen ? "nav-page2 transform" : "nav-page2"}>
            <div class="navigation_menu">
              <a href="#" onClick={() => go("/events")}>
                Upcoming Events
              </a>
              <a href="#" onClick={() => go("/request-demo")}>
                Request a Demo
              </a>
              <a href="#" onClick={() => go("/testimonial")}>
                Testimonials
              </a>
              <a href="#" onClick={() => go("/contact-us")}>
                Contact Us
              </a>
              {/* Duplicate quick access to Tools on second column for large overlays if desired */}
              <a
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  setToolsMobileOpen((v) => !v);
                }}
              >
                Tools {isToolsMobileOpen ? "−" : "+"}
              </a>
              {isToolsMobileOpen && (
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    marginLeft: 16,
                  }}
                >
                  <a href="#" onClick={() => go("/hs-code")}>
                    HS‑Code Tools
                  </a>
                  <a href="#" onClick={() => go("/tarrif-rules")}>
                    Tariff & Rules Tool
                  </a>
                </div>
              )}
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default Header;
